import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import StringInput from "../../components/Input/StringInput/StringInput";
import ValidationError from "../../components/ValidationError/ValidationError";
import Skeleton from "react-loading-skeleton";
import Select from "../../components/Input/Select/Select";
import { updateDailyCheckInRuleSetting } from "../../store/ducks/dailyCheckIn/actions";
import Swal from "sweetalert2";

const gameVendorSlugMap = {
  null: undefined,
  pp: "Pragmatic Play",
};

class DailyCheckInUpdateRuleSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      loading: true,
      id: null,
      day: 1,
      vipLevel: "",
      reward_free_spin_provider: 0,
      reward_total_free_spin: 0,
      reward_credit: 0,
      reward_coin: 0,
      required_deposit: 0,
      required_turnover: 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ruleSetting !== this.props.ruleSetting) {
      this.setState({
        loading: false,
        ...this.props.ruleSetting,
      });
    }

    if (
      prevProps.updateRuleSetting !== this.props.updateRuleSetting &&
      this.props.updateRuleSetting &&
      this.props.updateRuleSetting.data
    ) {
      if (this.props.updateRuleSetting.data.responseCode === 200) {
        const { t } = this.props;
        Swal.fire({
          icon: "success",
          title: t("global.success"),
          html: t("global.record-updated"),
          showConfirmButton: true,
        }).then(() => {
          this.props.onChangeTabIdHandler(null, "RULE_SETTING");
        });
      } else {
        this.setState({
          errMsg: "Unexpected Error",
        });
        Swal.close();
      }
    }
  }

  onSave(e) {
    e.preventDefault();

    const errors = [];

    if (
      this.state.reward_credit === null ||
      this.state.reward_credit === undefined ||
      this.state.reward_credit === ""
    ) {
      errors.push("Reward Credit is required");
    }

    if (
      this.state.reward_coin === null ||
      this.state.reward_coin === undefined ||
      this.state.reward_coin === ""
    ) {
      errors.push("Reward Coin is required");
    }

    if (
      this.state.required_deposit === null ||
      this.state.required_deposit === undefined ||
      this.state.required_deposit === ""
    ) {
      errors.push("Required Deposit is required");
    }

    if (
      this.state.required_turnover === null ||
      this.state.required_turnover === undefined ||
      this.state.required_turnover === ""
    ) {
      errors.push("Required Turnover is required");
    }

    if (errors.length) {
      this.setState({
        ...this.state,
        errors,
      });
      return;
    }

    this.props.updateDailyCheckInRuleSetting({
      id: this.state.id,
      rewardFreeSpinProvider: this.state.reward_free_spin_provider,
      rewardTotalFreeSpin: this.state.reward_total_free_spin,
      rewardCredit: this.state.reward_credit,
      rewardCoin: this.state.reward_coin,
      requiredDeposit: this.state.required_deposit,
      requiredTurnover: this.state.required_turnover,
    });
  }

  onInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      ...this.state,
      [name]: value,
    });
  }

  render() {
    const { t } = this.props;
    return (
      <Auxiliary>
        <div className="breadcrumb-header">
          <div className="d-flex">
            <div className="my-auto">
              <Button
                typeButton="button"
                classValue="btn btn-back-outline"
                idValue="back"
                buttonName={<i className="angle fe fe-chevron-left"></i>}
                clicked={(e) =>
                  this.props.onChangeTabIdHandler(e, "RULE_SETTING")
                }
              />
            </div>
          </div>
          <div className="my-auto">
            <div className="d-flex">
              <h4 className="content-title mb-0 my-auto ml-2">
                {t("global.daily-check-in-list-rule-setting")}
              </h4>
            </div>
          </div>
        </div>
        <div className="row row-sm">
          <div className="col-12">
            <div className="card  box-shadow-0">
              <div className="card-header">
                <h4 className="card-title mb-1">
                  {t("role.coin_setting_update")}
                </h4>
              </div>
              <div className="card-body pt-0">
                <div className="">
                  {this.state.errors.map((error, index) => (
                    <p key={index} className="text-danger">{error}</p>
                  ))}
                </div>
                <form
                  method="post"
                  id="update_rule_setting_form"
                  className="form-horizontal"
                  onSubmit={this.onSave}
                  noValidate
                >
                  <ValidationError
                    formName="update_rule_setting_form"
                    touched={false}
                    message={""}
                  />
                  {/* props hasn't loaded */}
                  {this.state.loading ? (
                    <Skeleton count={2} />
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-md-3 col-12 form-group">
                          <label htmlFor="day">{t("global.day")}</label>
                          <StringInput
                            id="day"
                            name="day"
                            className="form-control"
                            onChange={(e) => this.onInputChange(e)}
                            value={((+this.state.day || 0) + 1).toString()}
                            disabled
                          />
                        </div>
                        <div className="col-md-3 col-12 form-group ml-auto">
                          <label htmlFor="vip_level">
                            {t("global.membership-level")}
                          </label>
                          <StringInput
                            id="vip_level"
                            name="vip_level"
                            className="form-control"
                            onChange={(e) => this.onInputChange(e)}
                            value={this.state.vipLevel?.toString()}
                            disabled
                          />
                        </div>
                        <div className="col-md-3 col-12 form-group">
                          <label htmlFor="reward_free_spin_provider">
                            {t("global.reward-free-spin-provider")}
                          </label>
                          <Select
                            id="reward_free_spin_provider"
                            name="reward_free_spin_provider"
                            options={Object.keys(gameVendorSlugMap).map(
                              (key) => ({
                                label: gameVendorSlugMap[key],
                                value: key,
                              })
                            )}
                            onChange={(e) => this.onInputChange(e)}
                            value={this.state.reward_free_spin_provider}
                            className="form-control filter-input"
                          />
                        </div>
                        <div className="col-md-3 col-12 form-group ml-auto">
                          <label htmlFor="reward_total_free_spin">
                            {t("global.reward-total-free-spin")}
                          </label>
                          <NumberInput
                            onKeyPress={(evt) =>
                              (evt.key === "e" ||
                                evt.key === "-" ||
                                evt.key === "+") &&
                              evt.preventDefault()
                            }
                            onChange={(e) => this.onInputChange(e)}
                            id="reward_total_free_spin"
                            name="reward_total_free_spin"
                            placeholder={t("global.reward-total-free-spin")}
                            value={this.state.reward_total_free_spin}
                            required
                          />
                        </div>
                        <div className="col-md-3 col-12 form-group">
                          <label htmlFor="reward_credit">
                            {t("global.reward-credit")}
                          </label>
                          <NumberInput
                            onKeyPress={(evt) =>
                              (evt.key === "e" ||
                                evt.key === "-" ||
                                evt.key === "+") &&
                              evt.preventDefault()
                            }
                            onChange={(event) => this.onInputChange(event)}
                            id="reward_credit"
                            name="reward_credit"
                            placeholder={t("global.reward-credit")}
                            value={this.state.reward_credit}
                            required
                          />
                        </div>
                        <div className="col-md-3 col-12 form-group">
                          <label htmlFor="reward_coin">
                            {t("global.reward-coin")}
                          </label>
                          <NumberInput
                            onKeyPress={(evt) =>
                              (evt.key === "e" ||
                                evt.key === "-" ||
                                evt.key === "+") &&
                              evt.preventDefault()
                            }
                            onChange={(event) => this.onInputChange(event)}
                            id="reward_coin"
                            name="reward_coin"
                            placeholder={t("global.reward-coin")}
                            value={this.state.reward_coin}
                            required
                          />
                        </div>
                        <div className="col-md-3 col-12 form-group">
                          <label htmlFor="required_deposit">
                            {t("global.required-deposit")}
                          </label>
                          <NumberInput
                            onKeyPress={(evt) =>
                              (evt.key === "e" ||
                                evt.key === "-" ||
                                evt.key === "+") &&
                              evt.preventDefault()
                            }
                            onChange={(event) => this.onInputChange(event)}
                            id="required_deposit"
                            name="required_deposit"
                            placeholder={t("global.required-deposit")}
                            value={this.state.required_deposit}
                            required
                          />
                        </div>
                        <div className="col-md-3 col-12 form-group">
                          <label htmlFor="required_turnover">
                            {t("global.required-turnover")}
                          </label>
                          <NumberInput
                            onKeyPress={(evt) =>
                              (evt.key === "e" ||
                                evt.key === "-" ||
                                evt.key === "+") &&
                              evt.preventDefault()
                            }
                            onChange={(event) => this.onInputChange(event)}
                            id="required_turnover"
                            name="required_turnover"
                            placeholder={t("global.required-turnover")}
                            value={this.state.required_turnover}
                            required
                          />
                        </div>
                        <div className="col-md-12 form-group mb-0 justify-content-end">
                          <div>
                            <Button
                              typeButton="submit"
                              classValue="btn btn-blue"
                              idValue="save"
                              buttonName={t("global.save")}
                              clicked={(e) => this.onSave(e)}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </Auxiliary>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateDailyCheckInRuleSetting: (data) =>
      dispatch(updateDailyCheckInRuleSetting(data)),
  };
};

const mapStateToProps = (reduxState) => {
  return {
    updateRuleSetting: reduxState.dailyCheckIn.updateRuleSetting,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(DailyCheckInUpdateRuleSetting));
